<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>

    <notifications position="bottom center" width="100%"/>
  </v-app>
</template>

<script>
export default {
  name: 'App',


  data: () => ({
    //
  }),
};
</script>
